<script lang="ts">
    import CTA from "$lib/Components/Order/CTA.svelte";
    import towtruck from "$lib/assets/images/order/towtruck.jpg";
</script>

<section>
    <div class="wrapper">
        <div class="left">
            <CTA title="Bumper to bumper means peace of mind" isLight={true} btnColor="variant-filled-secondary" titleFont="text-secondary-500" text="Our comprehensive protection plans cover critical systems like the engine, transmission, cooling, electrical, and more, providing peace of mind against unexpected repairs. Drive with confidence and comfort, knowing you're backed by the best in vehicle protection" button="Get Started Now" />
        </div>
        <div class="right">
            <div class="right-image"></div>
            <!-- <img src={towtruck} alt="woman holding her phone while car is towed" /> -->
        </div>
    </div>
</section>

<style>
    section {
        @apply bg-primary-500;
        width: 100% !important;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: auto;
        flex-grow: 1;
        display: flex;

        margin: 0;
        padding: 0;
    }

    .wrapper {
        display: flex;
        justify-content: center;
        flex-direction: column-reverse;
        align-items: center;
        margin: auto;
        width: 100%;
        flex-wrap: nowrap;

        margin: auto;
    }
    .left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding: 2rem;
        margin: 2rem 0;
        min-width: 40%;

        max-width: 600px;
    }
    .right {
        width: 100%;
        min-width: 60%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .right-image {
        background-image: url("$lib/assets/images/order/towtruck.jpg");
        width: 100%;
        height: 200px;
        background-size: cover;
        background-position: left;

        background-repeat: no-repeat;
    }
    img {
        width: 100%;
        max-width: 600px;

        background-image: fill;
    }
    @media screen and (min-width: 768px) {
        .wrapper {
            flex-direction: row;
            justify-content: space-evenly;

            align-items: center;
            margin: 0;
            width: 100%;
            flex-wrap: nowrap;
        }
        .left {
            align-items: center;

            margin: 0;
        }
        .right {
            align-items: center;
        }
        .right-image {
            background-position: center;
            /* min-height: 400px;
             */
            height: 420px;
        }
    }
</style>
